import { Component, inject } from '@angular/core';
import { LANGS } from '../../shared/constants/lang.constants';
import { ReactiveFormsModule } from '@angular/forms';
import { TextComponent } from '../../shared/components/text/text.component';
import { TagComponent } from '../../shared/components/tag/tag.component';
import { MatTab, MatTabGroup } from "@angular/material/tabs";
import { Router } from '@angular/router';
import { SharedStorageService } from '../../shared/services/shared-storage.service';
import { CreateMemberRequest } from '../../shared/interfaces/set-password.model';
import { TranslatePipe } from '@ngx-translate/core';
import { MatButton } from "@angular/material/button";
import { MyReportsComponent } from "../reports/my-reports.component";
import { DatePipe } from '@angular/common';
import { FormatDatePipe2 } from '../../pipes/format-date.pipe';

/**
 * 我的健康檔案
 */
@Component({
  selector: 'app-my-health-profile',
  imports: [
    ReactiveFormsModule, 
    TextComponent, 
    TagComponent, 
    MatTab, 
    MatTabGroup, 
    TranslatePipe, 
    MatButton, 
    MyReportsComponent,
    DatePipe,
  ],
  templateUrl: './my-health-profile.component.html',
  styleUrl: './my-health-profile.component.scss',
})
export class MyHealthProfileComponent {
  LANGS = LANGS;
  selectedTab: number = 0; // 預設顯示第一個 tab
  router: Router = inject(Router);
  sharedStorageService: SharedStorageService = inject(SharedStorageService);
  createMemberRequest: CreateMemberRequest | null = null;
  isLoading: boolean = true;
  noData: boolean = false;
  formatDatePipe2 = new FormatDatePipe2();
  isProfileVisible: boolean = false;
  maskDots: number[] = [];

  ngOnInit() {
    // 取得會員資料
    this.createMemberRequest = this.sharedStorageService.get('createMemberRequest') || null;
    if (this.createMemberRequest) {
      this.isLoading = false;
      this.maskDots = Array(this.createMemberRequest.name?.length || 4).fill(0);
    }
  }

  // 取得姓名
  get userName(): string {
    return this.createMemberRequest?.name || '';
  }

  // 取得性別
  get userGender(): string {
    return this.createMemberRequest?.gender === 'M' ? '男性' : '女性';
  }

  // 取得生日
  get userBirthday(): string {
    const birthday = this.createMemberRequest?.birthday ?? '';
    return this.formatDatePipe2.transform(birthday);
  }

  // 導轉修改個人資料頁面
  modifyProfile() {
    this.router.navigate(['/healthcheck/member/editprofile']).then();
  }

  // 顯示個資遮罩
  toggleProfileVisibility(): void {
    this.isProfileVisible = !this.isProfileVisible;
  }
}
